export default {
  filterPlaceholder: 'Filtruj według stanu',
  confirmDelete: 'Usunięcie stanu pliku "{filePathId}" nie usuwa samego pliku dziennika. Następna runda wykrywania znajdzie go ponownie i zaimportuje. Kontynuować?',
  resetSelected: 'Resetuj wybrane ({count})',
  confirmBulkDelete: 'Usunięcie stanu {count} plików dziennika nie usuwa samych plików dziennika. Następna runda wykrywania znajdzie je ponownie i zaimportuje. Kontynuować?',
};
